import {combineReducers} from 'redux';
import {ACTION_TYPES} from "../actions";
import _ from 'lodash';

const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

const DEFAULT_RUBRIC = {
    criteria_title: "New Criterion",
    ratings: [
        {rating_title: "No Marks", rating_description: "Describe your lowest rating here", points: 0},
        {rating_title: "Full Marks", rating_description: "Describe your highest rating here", points: 5}
    ],
    max_points: 5
};

// takes care if user is logged in/out
const authReducer = function (state = null, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_USER:
            return action.payload || false;
        default:
            return state;
    }
};

const reviewerReducer = function (state = [], action) {
    let newState = state;
    const isUnique = state.length === 0 || !state.map(reviewer => reviewer.unid).includes(action.payload.unid);
    switch (action.type) {
        case ACTION_TYPES.SET_FIELDS.SET_REVIEWERS:
            newState = action.payload.reviewers;
            return newState;
        case ACTION_TYPES.ADD_REVIEWER:
            if (isUnique) {
                const newArray = [...state, action.payload];
                return newArray;
            }
        case ACTION_TYPES.REMOVE_REVIEWER:
            if (!isUnique) {
                const indexToRemove = state.map(reviewer => reviewer.unid).indexOf(action.payload.unid);
                const newArray = [...state];
                newArray.splice(indexToRemove, 1);
                return newArray;
            }
        case ACTION_TYPES.UPDATE_REVIEWER:
            // DEEP COPY
            const newArray = deepCopy(state);
            const reviewersToUpdate = newArray.map(reviewer => {
                if(reviewer.unid === action.payload.unid)
                    return deepCopy(action.payload);
                else
                    return reviewer;
            });
            return reviewersToUpdate;
        default:
            return state;
    }
};

const canvasUserReducer = function (state = [], action) {
    const isUnique = state.length === 0 || !state.map(canvasUser => canvasUser.unid).includes(action.payload.unid);
    switch (action.type) {
        case ACTION_TYPES.ADD_CANVAS_USER:
            if (isUnique) {
                const newArray = state.concat(action.payload);
                return newArray;
            }
        case ACTION_TYPES.REMOVE_CANVAS_USER:
            if (!isUnique) {
                const indexToRemove = state.map(canvasUser => canvasUser.unid).indexOf(action.payload.unid);
                const newArray = [...state];
                newArray.splice(indexToRemove, 1);
                return newArray;
            }
        case ACTION_TYPES.RESET_CANVAS_USERS:
            return [];
        default:
            return state;
    }
};

const collegesFillerReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_COLLEGES:
            return action.payload.colleges;
        default:
            return state;
    }
}

const departmentsFillerReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_DEPARTMENTS:
            return action.payload.departments;
        default:
            return state;
    }
}

const programsFillerReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_PROGRAMS:
            return action.payload.programs;
        default:
            return state;
    }
}

const outcomesFillerReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_OUTCOMES:
            return action.payload.outcomes;
        default:
            return state;
    }
}

const coursesFillerReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_COURSES:
            return action.payload.courses;
        default:
            return state;
    }
}

const artifactsFillerReducer = function (state = {}, action) {
    let newState = state;
    switch (action.type) {
        case ACTION_TYPES.FETCH_ARTIFACTS:
            return action.payload.artifacts;
        case ACTION_TYPES.SWAP_ARTIFACT:
            if ((action.payload.artifact) != null) {
                const indexToRemove = newState.map(artifact => artifact.canvas_submission_id).indexOf(action.payload.old_artifact_id);
                newState.splice(indexToRemove, 1);
                newState.push(action.payload.artifact);
            }
            return newState;
        default:
            return state;
    }
}

const termsFillerReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.FETCH_TERMS:
            return action.payload;
        default:
            return state;
    }
}

const assessmentsReducer = function (state = {}, action) {
    let newState = state;
    switch (action.type) {
        case ACTION_TYPES.FETCH_ALL_ASSESSMENTS:
            return action.payload;
        case ACTION_TYPES.FETCH_FILTERED_ASSESSMENTS:
            return action.payload;
        case ACTION_TYPES.FETCH_ASSESSMENTS:
            return action.payload.assessments;
        case ACTION_TYPES.REMOVE_ASSESSMENT:
            const indexToRemove = newState.docs.map(assessment => assessment._id).indexOf(action.payload);
            newState.docs.splice(indexToRemove, 1);
            return newState;
        case ACTION_TYPES.UPDATE_ASSESSMENT:
            return action.payload;
        default:
            return state;
    }
}

const filteredAssessmentsReducer = function (state = {}, action){
    let newState = state;
    switch(action.type){
        case ACTION_TYPES.SET_FIELDS.SET_IS_ALL_ASSESSMENTS_VIEW:
            newState.adminView = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_FILTER_INPUTS:
            newState = action.payload;
            return newState;
        default:
            return state;
    }
}

const assessmentReducer = function (state = {}, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_ASSESSMENT:
            return action.payload;
        default:
            return state;
    }
}

const reviewReducer = function (state = {}, action) {
    let newState = state;
    switch (action.type) {
        case ACTION_TYPES.FETCH_REVIEWS:
            return action.payload.reviews;
        default:
            return state;
    }
}

const newAssessmentFormReducer = function (state = {}, action) {
    let newState = state;
    switch (action.type) {
        case ACTION_TYPES.SET_FIELDS.SET_NAME:
            newState.name = action.payload.name;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_COLLEGE:
            newState.college = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_DEPARTMENT:
            newState.department = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_PROGRAM:
            newState.program = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_TERM:
            newState.terms = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_OUTCOME:
            newState.outcome = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.ADD_COURSE:
            (newState.courses = newState.courses || []).push(action.payload);
            return newState;
        case ACTION_TYPES.SET_FIELDS.REMOVE_COURSE:
            _.remove(newState.courses, item => item === action.payload);
            return newState;
        case ACTION_TYPES.FETCH_COURSES:
            newState.courses = [];
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS:
            newState.numArtifacts = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS_PER_REVIEWER:
            newState.numArtifactsPerReviewer = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_NUM_ARTIFACTS_PER_TIER:
            newState.numArtifactsPerTier = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_BELL_CURVE_CHECKED:
            newState.checked = action.payload;
            return newState;
        case ACTION_TYPES.SET_FIELDS.SET_MULTI:
            newState = action.payload;
            return newState;
        default:
            return state;
    }
}

const rubricReducer = function (state = [DEFAULT_RUBRIC], action) {
    let newState = state;
    switch (action.type) {
        case ACTION_TYPES.UPDATE_RUBRICS:
            return [...action.payload];
        case ACTION_TYPES.RESET_RUBRICS:
            return [action.payload];
        case ACTION_TYPES.SET_FIELDS.SET_RUBRIC:
            newState = action.payload.rubrics;
            return newState;
        default:
            return state;
    }
};

const rubricsReducer = function (state = {}, action) {
    let newState = state;
    switch (action.type) {
        case ACTION_TYPES.RESET_RUBRIC_LIST:
            return action.payload;
        case ACTION_TYPES.FETCH_RUBRICS:
            return action.payload;
        case ACTION_TYPES.DELETE_RUBRIC:
            const indexToRemove = newState.map(rubric => rubric._id).indexOf(action.payload._id);
            newState.splice(indexToRemove, 1);
            return newState;
        default:
            return state;
    }
}

const commentsReducer = function ( state = {}, action) {
    let newState = state;
    switch(action.type){
        case ACTION_TYPES.FETCH_REVIEWER_COMMENTS:
            return action.payload;
        default:
            return state;
    }
}

export default combineReducers({
    assessments: assessmentsReducer,
    assessment: assessmentReducer,
    filteredAssessmentsForm:filteredAssessmentsReducer,
    user: authReducer,
    colleges: collegesFillerReducer,
    departments: departmentsFillerReducer,
    terms: termsFillerReducer,
    programs: programsFillerReducer,
    outcomes: outcomesFillerReducer,
    courses: coursesFillerReducer,
    newAssessmentForm: newAssessmentFormReducer,
    reviewers: reviewerReducer,
    artifacts: artifactsFillerReducer,
    canvasUsers: canvasUserReducer,
    rubrics: rubricReducer,
    rubricsList: rubricsReducer,
    reviews: reviewReducer,
    comments: commentsReducer,
});
